import type {
    TraceErrorObject,
    CustomDataMap,
    INTERNAL_ONLY_SYSTEM_METADATA_GLOBAL_ACCOUNT,
} from 'owa-analytics-types';
import { AriaDatapoint } from './AriaDatapoint';
import { getActionMetadata } from '../utils/getActionMetadata';

import { getErrorHash } from 'owa-analytics-utils/lib/ignoreError';
import { addEncounteredErrorCode } from 'owa-error-codes';
import type { MailboxInfo } from 'owa-client-types';

const diagnosticsColumn = 'diagnostics';

export default class ErrorDatapoint extends AriaDatapoint {
    constructor(
        message: string,
        mailboxInfo: MailboxInfo | typeof INTERNAL_ONLY_SYSTEM_METADATA_GLOBAL_ACCOUNT | undefined,
        details: TraceErrorObject | undefined,
        props: CustomDataMap
    ) {
        const hash = getErrorHash(message, details);
        super(<string>hash, mailboxInfo, undefined, undefined, props);
        try {
            let diagnosticInfo = JSON.stringify({
                ...details?.additionalInfo,
                diagnosticInfo: details?.diagnosticInfo || '',
            });
            const { stack, queue } = getActionMetadata();
            if (stack && stack.length > 0) {
                diagnosticInfo += '|stack:' + stack;
            }
            if ((details?.component || details?.addQueue) && queue && queue.length > 0) {
                diagnosticInfo += '|queue:' + queue;
            }
            this.addDataWithPiiScrubbing(diagnosticsColumn, diagnosticInfo);
            if (self?.navigator && typeof self.navigator.onLine == 'boolean') {
                this.addData('online', self.navigator.onLine);
            }
            if (details?.owaErrorCode) {
                addEncounteredErrorCode(details.owaErrorCode);
                this.addData('ErrorCode', details.owaErrorCode);
            }
        } catch (e) {
            // Errors resulting from enabling useUnknownInCatchVariables
            // TS18046: 'e' is of type 'unknown'.
            // @ts-expect-error
            this.addDataWithPiiScrubbing(diagnosticsColumn, e.message);
        }
    }
}
